export const SANDBOX_ADD_FUNDS_BUTTON_TEST_ID = 'sandbox-add-funds-button';
export const SANDBOX_ADD_FUNDS_MODAL_TEST_ID = 'sandbox-add-funds-modal';
export const SANDBOX_ADD_FUNDS_AMOUNT_INPUT_TEST_ID =
  'sandbox-add-funds-amount-input';
export const SANDBOX_ADD_FUNDS_CURRENCY_SELECT_TEST_ID =
  'sandbox-add-funds-currency-select';
export const SANDBOX_ADD_FUNDS_SUBMIT_TEST_ID = 'sandbox-add-funds-submit';
